import Spinner from "app/components/Icons/Spinner";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CollapseCard from "../../../Home/components/CollapseCard";
import ColumnComponents from "../../../Home/components/ColumnComponents";
import AddHiddenGroup from "../../../Home/components/ColumnComponents/AddHiddenGroup";
import {
  selectTicketFormDetail,
  selectTicketGroups,
} from "../../redux/selector";
import { actions, actions as ticketActions } from "../../redux/slice";
import CircularLoader from "app/components/CircularLoader";

export default function Kanban() {
  const dispatch = useDispatch();
  const groups = useSelector(selectTicketGroups);
  const ticketGroup = useSelector(selectTicketFormDetail);

  const handleDragEnd = (
    ticketId: string,
    sourceStatus: string,
    targetStatus: string
  ) => {
    if (sourceStatus === targetStatus) return;

    dispatch(
      actions.updateTicketStatus({
        ticketId,
        sourceStatus,
        targetStatus,
      })
    );

    // Here you would also make an API call to update the backend
    // For now, we're just updating the Redux state
  };
  const onCancel = () => {
    dispatch(ticketActions.clearCreateTicketForm());
  };

 

  return (
    <div className="flex-shrink-0 w-full h-[calc(100vh-160px)] overflow-x-auto px-[24px] ">
      <div className="w-full max-w-[calc(100vw-76px)] h-full flex flex-row  gap-[16px]">
        <CollapseCard />
        <div className="flex  gap-[16px] h-full min-w-[max-content] w-full">
          {groups?.length > 0 ? (
            groups.map((group, index) => {
              return (
                //filter according the group actions
                !group.isCollapse &&
                !group.isHidden && (
                  <div key={index} className="w-[255px]">
                    <ColumnComponents
                      key={index}
                      group={group}
                      onDragEnd={handleDragEnd}
                      showAddTaskIcon={ticketGroup?.groupId === group?._id}
                      selectedType={ticketGroup.type}
                      onCancel={onCancel}
                    
                    />
                  </div>
                )
              );
            })
          ) : (
            <div className="flex justify-center items-center h-full w-full">
             <CircularLoader size='xl' />
            </div>
          )}
        </div>
        <AddHiddenGroup />
      </div>
    </div>
  );
}
